export const AppConstant = {
    vippsAppName: 'Vipps',
    smsName: 'SMS',
    User: 'Bruker kansellerte påloggingen',
    invalidDeviceId: 'Butikkenheten er ugyldig',
    vippsCodeInvalid: 'Brukeren valgte feil kode.',
    vippsUserCancelRequest: 'Bruker kansellerte påloggingen',
    sendButtonText: 'Send',
    sendButtonOkText: 'OK',
    deviceClassName: 'DeviceClass',
    success: 'Success',
    error: 'Error'
}

export const DeviceClassEnum = {
    none: 'None',
    doorAccess: 'DoorAccess',
    gateAccess: 'GateAccess',
    retailDOBAccess: 'RetailDOBAccess',
    retailAlcoholAccess: 'RetailAlcoholAccess',
    venAccess: 'VenAccess',
    mimic: 'Mimic'
};